/**
 * Prenotazioni Page - Page Shell
 * Lista prenotazioni
 */

import { PrenotazioniList } from "@/features/prenotazioni";

export default function Prenotazioni() {
  return <PrenotazioniList />;
}
